import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllSeedListByClientId = async (clientId: number) => {
    const response = http.get(`/seedlist/all?clientId=${clientId}`);
    return response;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addSeedList = async (data: any) => {
    const response = http.post(`/seedlist/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const deleteSeedList= async (seedListId: any, modifiedById: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-template-expressions
    const response = http.delete(`/seedlist/delete?seedListId=${seedListId}&modifiedBy=${modifiedById}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getSeedListById = async (id?: number) => {
    const response = http.get(`/seedlist/${id !== undefined ? id : ''}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updateSeedList = async (data: any) => {
    const response = http.put(`/seedlist/update`, data)
    return response;
}